import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient) { }

  agregarContacto(formContacto) {
	  return this.http.post(environment.API_SECURITY + '/api/Contacto', formContacto);
  }
}
